import React from 'react';
import { StickyHeader } from '../components/StickyHeader';
import { HeroSection } from '../components/HeroSection';
import { EmotionalContext } from '../components/EmotionalContext';
import { ForWhoSection } from '../components/ForWhoSection';
import { ThreePillars } from '../components/ThreePillars';
import { CentralPromise } from '../components/CentralPromise';
import { ValentinesSection } from '../components/ValentinesSection';
import { Deliverables } from '../components/Deliverables';
import { PricingCTA } from '../components/PricingCTA';
import { Guarantee } from '../components/Guarantee';
import { FAQSection } from '../components/FAQSection';
import { EmotionalClose } from '../components/EmotionalClose';
export function SalesPage() {
  return <div className="min-h-screen bg-[#0A0A0A] text-[#FAF7F2] font-sans selection:bg-[#C5A55A] selection:text-white" data-id="element-169">
      <StickyHeader data-id="element-170" />
      <main data-id="element-171">
        <HeroSection data-id="element-172" />
        <EmotionalContext data-id="element-173" />
        <ForWhoSection data-id="element-174" />
        <ThreePillars data-id="element-175" />
        <CentralPromise data-id="element-176" />
        <ValentinesSection data-id="element-177" />
        <Deliverables data-id="element-178" />
        <PricingCTA data-id="element-179" />
        <Guarantee data-id="element-180" />
        <FAQSection data-id="element-181" />
        <EmotionalClose data-id="element-182" />
      </main>

      <footer className="bg-[#050505] py-8 text-center text-[#FAF7F2]/30 text-xs" data-id="element-183">
        <p data-id="element-184">© 2024 Inmersión Pareja. Todos los derechos reservados.</p>
      </footer>
    </div>;
}